// Descarga robusta de un Blob como archivo.
// Arregla dos fallos comunes: (1) el <a> debe estar en el DOM para que .click()
// dispare la descarga en Firefox/algunos Chrome; (2) revocar el object URL de
// forma síncrona tras .click() cancela la descarga — hay que diferirlo.
export function descargarBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}
